import React from 'react';
import { observer } from 'mobx-react';
import type ReserveInfo from '@this/domain/reserve_info';

type Props = {
  reserveInfo: ReserveInfo;
};

const WelfareSection: React.FC<Props> = ({ reserveInfo }) => (
  <label data-testid="reserve-confirm-input-welfare-private-use-root">
    <input
      data-testid="reserve-confirm-input-welfare-private-use-checkbox"
      type="checkbox"
      checked={reserveInfo.privateUse}
      onChange={() => {
        reserveInfo.privateUse = !reserveInfo.privateUse;
      }}
    />
    <span data-testid="reserve-confirm-input-welfare-private-use-label">プライベート利用</span>
  </label>
);

export default observer(WelfareSection);
